  
    <head>
      <meta charset="utf-8">
      <title>Hello Analytics Reporting API V4</title>
      <meta name="google-signin-client_id" content="565998685768-tkr64eaqn6h8ufribc5ovjmuvggdqo7v.apps.googleusercontent.com">
      <meta name="google-signin-scope" content="https://www.googleapis.com/auth/analytics.readonly">
    </head>
    <div class="container-fluid d-flex">
      <div class="col border">
        <h4>Utilisateurs actifs :</h4>
        <ul>
          <li *ngFor="let user of userList">
            <ul>
              {{user.email}} 
              <i *ngIf="modify==null" class="fa fa-minus" aria-hidden="true" (click)="setInactive(user.id)"></i>
            </ul>
            <ul>
              Nom : {{user.name}} 
              <i class="fa fa-pencil" aria-hidden="true" (click)="showModif(user.id)"></i>
            </ul>
          </li>
        </ul>
        <h4 *ngIf=" inactiveList.length > 0">Utilisateurs inactifs :</h4>
        <ul>
          <li *ngFor="let user of inactiveList">
            <ul>{{user.email}} <i *ngIf="modify==null" class="fa fa-plus" aria-hidden="true" (click)="setActive(user.id)"></i></ul>
          </li>
        </ul>
        <h4 *ngIf=" adminList.length > 0">Liste des administrateurs :</h4>
        <ul>
          <li *ngFor="let user of adminList">
            <ul>{{user.name}}</ul>
          </li>
        </ul>
      </div>
      <div class="col border">
        <h3>Liste des services : </h3>
        <ul *ngIf="devList.length > 0">
          <h5>Dev :</h5>
          <li *ngFor="let user of devList">  
            <ul>{{user.email}}</ul>
            <ul>{{user.name}}</ul>
          </li>
        </ul>
        <ul *ngIf=" marketingList.length > 0">
          Marketing : 
          <li *ngFor="let user of marketingList">  
            <ul>{{user.email}}</ul>
            <ul>{{user.name}}</ul>
          </li>
        </ul>
        <ul *ngIf="operationList.length > 0">
          operation : 
          <li *ngFor="let user of operationList">  
              <ul>{{user.email}}</ul>
              <ul>{{user.name}}</ul>
          </li>
        </ul>
        <ul *ngIf=" prodList.length > 0">
          Prod : 
          <li *ngFor="let user of prodList">  
            <ul>{{user.email}}</ul>
            <ul>{{user.name}}</ul>
          </li>
        </ul>
      </div>
      <div class="col border">
          <ul *ngFor="let user of userList" >
            <div class="container-fluid" *ngIf="modify == user.id">
              <h4>Modifier l'utilisateur : {{user.email}}</h4>
              <ul *ngIf="modify == user.id">
                <form [formGroup]='modifForm' (ngSubmit)='sendModif(user.id, user.service, user.email, user.profil)'>
                  <div class="form-group">
                    <label for="name">Nom de l'utilisateur</label>
                    <input type="text" class="form-control" id="name" value="{{user.name}}" formControlName="name">
                  </div>
                  <mat-form-field appearance="fill">
                    <mat-label for="name">Service</mat-label>
                        <mat-select class="custom-select" id="service" formControlName='service'>
                          <mat-option [selected]="user.service == 'autre'" value="autre">...</mat-option>
                          <mat-option [selected]="user.service == 'Marketing'" value="Marketing">Marketing</mat-option>
                          <mat-option [selected]="user.service == 'Operation'" value="Operation">Operation</mat-option>
                          <mat-option [selected]="user.service == 'Prod'" value="Prod">Prod</mat-option>
                          <mat-option [selected]="user.service == 'Dev'" value="Dev">Dev</mat-option>
                        </mat-select>  
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label for="profil">Profil</mat-label>
                        <mat-select class="custom-select" id="profil" formControlName='profil'>
                          <mat-option [selected]="user.profil == 'utilisateur'" value="utilisateur">Utilisateur</mat-option>
                          <mat-option [selected]="user.profil == 'admin'" value="admin">Admin</mat-option>
                        </mat-select>  
                  </mat-form-field>
                  <div class="input-group" id="button-addon4">
                    <button class="btn btn-outline-secondary" type="submit" [disabled]='modifForm.invalid'><i class="fa fa-check" aria-hidden="true"></i></button>
                    <button class="btn btn-outline-secondary" type="button" (click)="showModif(user.id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                  </div>
                </form>
              </ul>
              
            </div>
          </ul>
      </div> 
    </div>